import React, { useState } from 'react';
import { withAppContext } from '../../contexts/AppContext';
import { ReactSVG } from 'react-svg';
import BottomSheetSelect from '../BottomSheetSelect/BottomSheetSelect';
import i18n from '../../i18n/i18n';
import './ProductListControlls.css';

const ProductListControlls = ({ onToggleFilter, onSortChange, productCount, sortBy,activeFiltersCount, isFilterOpen }) => {

    const [sortOpen, setSortOpen] = useState(false);

    let sortOptions = [];

    if(sortBy?.values){
        Object.keys(sortBy.values).forEach(key => {
            sortOptions.push({ value: key, label: sortBy.values[key] });
        });
    }

    return (
        <>
            <div className="product-list-controlls">
                <div className="product-count">
                    {productCount} {i18n.t('productListControllsDispayedProducts')}
                </div>
                <div className="controlls">
                    <button className='controll-icon icon-order-by' onClick={() => setSortOpen(true)}>
                        <ReactSVG src="/assets/images/icon-sort.svg" />
                        {i18n.t('productListControllsSortByLabel')}
                    </button>
                    <button className='controll-icon icon-filter' onClick={() => onToggleFilter((isFilterOpen ? 0 : 1))}>
                        <ReactSVG src="/assets/images/icon-filter.svg" />
                        {i18n.t('productListControllsFilterButton')}

                        {activeFiltersCount > 0 && (
                            <span className="active-filters-count">{activeFiltersCount}</span>
                        )}
                    </button>
                </div>
            </div>
            <BottomSheetSelect
                isOpen={sortOpen}
                onClose={() => setSortOpen(false)}
                options={sortOptions}
                onChange={onSortChange}
                selectedValue={sortBy.selected}
                title={i18n.t('productListControllsSortByLabel')}
            />
        </>
    );
};

export default withAppContext(ProductListControlls);
